import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../../shared-components/System';
import { YearService } from '../../../shared-components/year/year.service';
import { AttendanceCodes, AttendanceOptions, AttendanceStepDefinition, AttendanceCodeStepDefinition, ReportingSystemTemplatesForAttendance } from './school-settings-attendance.model';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SchoolSettingsAttendanceService {

  constructor(
    private http: HttpClient,
    private yearService: YearService
  ) { }

  getSchoolSettingsAttendanceCode(): Observable<AttendanceCodes[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.get<AttendanceCodes[]>(System.apiURL.Management + 'GetSchoolSettingsAttendanceCode' + queryString);
  }

  updateSchoolSettingsAttendanceCode(data: AttendanceCodes[]): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.post<boolean>(System.apiURL.Management + 'UpdateSchoolSettingsAttendanceCode' + queryString, data);
  }

  getSchoolSettingsAttendanceOptions(): Observable<AttendanceOptions[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.get<AttendanceOptions[]>(System.apiURL.Management + 'GetSchoolSettingsAttendanceOptions' + queryString);
  }

  updateSchoolSettingsAttendanceOptions(data: AttendanceOptions): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.post<boolean>(System.apiURL.Management + 'UpdateSchoolSettingsAttendanceOptions' + queryString, data);
  }

  getSchoolSettingsStepDefinitions(): Observable<AttendanceStepDefinition[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.get<AttendanceStepDefinition[]>(System.apiURL.Management + 'GetSchoolSettingsStepDefinitions' + queryString);
  }

  getSchoolSettingsAttendanceCodeByStepDefinitionId(stepDefinitionId: number): Observable<AttendanceCodeStepDefinition[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&stepDefinitionId=' + stepDefinitionId;
    return this.http.get<AttendanceCodeStepDefinition[]>(System.apiURL.Management + 'GetAttendanceCodesByStepDefinitionId' + queryString);
  }

  updateAttendanceTrackingGroup(data: AttendanceStepDefinition, ac: AttendanceCodes[]): Observable<string> {
    data.AttendanceCodes = _.cloneDeep(ac);
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.post<string>(System.apiURL.Management + 'UpdateAttendanceTrackingGroup' + queryString, data);
  }

  attendanceStepDEfinitionDuplicateCheck(description: string): Observable<number> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&description=' + description;
    return this.http.get<number>(System.apiURL.Management + 'AttendanceStepDEfinitionDuplicateCheck' + queryString);
  }

  stepSystemRunBatch(templateId: number): Observable<any> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&templateId=' + templateId;
    return this.http.get(System.apiURL.Management + 'StepSystemRunBatch' + queryString);
  }

  getSchoolSettingsReportingSystemTemplates(): Observable<ReportingSystemTemplatesForAttendance[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.get<ReportingSystemTemplatesForAttendance[]>(System.apiURL.Management + 'GetSchoolSettingsReportingSystemTemplates' + queryString);
  }

  deleteAttendanceTrackingGroup(templateId: number): Observable<any> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&templateId=' + templateId;
    return this.http.get(System.apiURL.Management + 'DeleteAttendanceTrackingGroup' + queryString);
  }
}
